export {
  useDeleteCommunicationAPI,
  resetDeleteCommunicationAPI,
} from './useDeleteCommunicationAPI';
export { reducerDeleteCommunicationAPI } from './reducerDeleteCommunicationAPI';
